import { useMediaQuery, useTheme } from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";
import React, { useMemo } from "react";
import { partyType, countries } from '../../fields/options'

export const useColumns = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () =>
      [
        columnHelper.accessor('partyMasterName', {
          header: () => 'Profile Name',
          cell: (info) => (
            <strong>
              {info.getValue()}
            </strong>
          ),
          filterFn: 'includesString',
          meta: {
            priority: 1,
            style: { whiteSpace: 'nowrap' }
          }
        }),
        columnHelper.accessor('name', {
          header: () => 'Company Name',
          filterFn: 'includesString',
          meta: { priority: 3, hideOnMobile: isMobile },
        }),
                columnHelper.accessor('partyCode', {
          header: () => 'Party Type',
          cell: (info) => {
            const partyCode = info.getValue();
            const label = partyType.find(c => c.value === partyCode)?.description ?? '-';
            return <span>{label}</span>;
          },
          meta: {
            priority: 2,
            filterVariant: 'selectOptions',
                        filterOptions: (() => {
              const seen = {}
              return [
                { label: 'All', value: '' },
                ...partyType.map(p => {
                  const isDup = partyType.filter(x => x.description === p.description).length > 1
                  return { label: isDup ? `${p.description} (${p.value})` : p.description, value: p.value }
                })
              ]
            })()
          },
        }),
        columnHelper.accessor('countryCode', {
          header: () => 'Country',
          cell: (info) => {
            const countryCode = info.getValue();
            const label = countries.find(c => c.value === countryCode)?.description ?? '-';
            return <span>{label}</span>;
          },
          meta: {
            priority: 2,
            filterVariant: 'selectOptions',
            filterOptions: [
              { label: 'All', value: '' },
              ...countries.map(c => ({ label: c.description, value: c.value }))
            ]
          },
        }),
        columnHelper.accessor('active', {
          header: () => 'Status',
          cell: (info) => (
            <span>{info.getValue() ? 'Active' : 'Inactive'}</span>
          ),
          filterFn: (row, columnId, filterValue) => {
            if (filterValue === 'all') return true // show all rows
            return row.getValue(columnId) === filterValue;
          },
          meta: {
            priority: 3,
            filterVariant: 'selectStatus',
            filterOptions: [
              { label: 'All', value: 'all' },  
              { label: 'Active', value: true },
              { label: 'Inactive', value: false }
            ]
          },
        }),
        columnHelper.accessor('updatedDate', {
          header: () => 'Last Update Date',
          enableSorting: true,
          cell: (info) => {
            const date = info.getValue();
            return <span>{date ? new Date(date).toLocaleString() : '-'}</span>;
          },
        }),
      ].filter((column) => {
        if (isSmall && column.meta?.hideOnMobile) return false;
        if (isTablet && column.meta?.hideOnTablet) return false;
        return true;
      }),
    [columnHelper, isMobile, isTablet, isSmall],
  );

  return columns
}